export const fetchPdfBytes = async (url: string, attempts = 3): Promise<ArrayBuffer> => {
  let lastError: unknown;
  for (let attempt = 1; attempt <= attempts; attempt += 1) {
    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`Failed to fetch PDF (${response.status})`);
      }
      return await response.arrayBuffer();
    } catch (error) {
      lastError = error;
      if (attempt < attempts) {
        await new Promise((resolve) => setTimeout(resolve, attempt * 400));
      }
    }
  }
  throw lastError instanceof Error ? lastError : new Error('Failed to fetch PDF');
};
